import React, { useEffect, useState } from "react";
import Footer from "./Footer";
import logoHeader from "../assets/klassefruehstueck-logo-header.png";

function PageShell({ children, maxWidth = "max-w-5xl" }) {
  const [theme, setTheme] = useState(() => {
    if (typeof window === "undefined") {
      return "light";
    }

    return window.localStorage.getItem("klassefruehstueck-theme") || "light";
  });
  const [isSwitchingTheme, setIsSwitchingTheme] = useState(false);

  const isDark = theme === "dark";

  useEffect(() => {
    window.localStorage.setItem("klassefruehstueck-theme", theme);
    document.documentElement.dataset.theme = theme;
  }, [theme]);

  useEffect(() => {
    if (!isSwitchingTheme) {
      return undefined;
    }

    const timer = window.setTimeout(() => {
      setIsSwitchingTheme(false);
    }, 720);

    return () => window.clearTimeout(timer);
  }, [isSwitchingTheme]);

  function toggleTheme() {
    setIsSwitchingTheme(true);
    setTheme(isDark ? "light" : "dark");
  }

  return (
    <main
      className={
        isDark
          ? "app-dark min-h-screen bg-[#0c100c] px-5 py-5 text-[#f4f7ee] sm:px-6 sm:py-8"
          : "min-h-screen bg-[#f2f5ec] px-5 py-5 text-neutral-950 sm:px-6 sm:py-8"
      }
    >
      <div className={`mx-auto ${maxWidth}`}>
        <div
          className={
            isDark
              ? "mb-9 border-b border-[#24351c] pb-5 print:hidden"
              : "mb-9 border-b border-[#dce8c8] pb-5 print:hidden"
          }
        >
          <div className="relative flex items-center justify-center px-14 py-2 sm:px-16 sm:py-3">
            <div className="logo-header">
              <img
                src={logoHeader}
                alt="KlasseFrühstück Logo"
                className="h-full w-full object-contain object-center"
              />
            </div>

            <button
              type="button"
              aria-label={isDark ? "Zum Lightmode wechseln" : "Zum Darkmode wechseln"}
              onClick={toggleTheme}
              className={
                isDark
                  ? `mode-toggle${isSwitchingTheme ? " is-changing" : ""} absolute right-0 top-1/2 -translate-y-1/2 rounded-full border border-[#314527] bg-[#121812] p-3 text-[#dcefb4] hover:bg-[#1b2419]`
                  : `mode-toggle${isSwitchingTheme ? " is-changing" : ""} absolute right-0 top-1/2 -translate-y-1/2 rounded-full border border-[#c9d9b4] bg-white p-3 text-[#39501f] shadow-sm hover:bg-[#eef5df]`
              }
            >
              <span className="mode-toggle__icon" aria-hidden="true">
                <span className="mode-toggle__check" />
                <span className="mode-toggle__lines">
                  <span />
                  <span />
                  <span />
                </span>
              </span>
            </button>
          </div>
        </div>
        {children}
        <Footer />
      </div>
    </main>
  );
}

export default PageShell;
